/* Home-only positioning of one existing comparison block; no card cloning. */
(function () {
  'use strict';
  var key = '__mgHomeComparisonPositionV1';
  if (window[key]) { window[key](); return; }
  var mobile = window.matchMedia('(max-width: 749px)');
  function positionAll() {
    document.querySelectorAll('.mg-home-curated').forEach(function (root) {
      var anchor = root.querySelector('[data-home-comparison-desktop-anchor]');
      var block = root.querySelector('[data-home-comparisons]');
      if (!anchor || !block || !anchor.parentNode) return;
      var topics = root.querySelector('#all-guides .mg-guide-catalogue > .mg-mobile-featured-topics');
      var heading = root.querySelector('#all-guides .mg-guide-catalogue > .mg-mobile-latest-guides-heading');
      if (mobile.matches && topics && heading && topics.parentNode === heading.parentNode) {
        if (block.nextElementSibling !== heading) heading.parentNode.insertBefore(block, heading);
      } else if (anchor.nextElementSibling !== block) {
        anchor.parentNode.insertBefore(block, anchor.nextSibling);
      }
    });
  }
  window[key] = positionAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', positionAll, { once: true });
  else positionAll();
  mobile.addEventListener('change', positionAll);
  document.addEventListener('shopify:section:load', positionAll);
  window.addEventListener('pageshow', positionAll);
}());
